var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.25L11.6757 2.61942C11.2934 2.26896 10.7066 2.26895 10.3243 2.61942L2 10.25",
    stroke: "#FF6B00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
};

export default __webpack_public_path__ + "static/media/arrow-up.c16c0a11.svg";
export { SvgArrowUp as ReactComponent };